import functions from '../../functions';

if (window.wp && window.wp.ajax)
{
    const { registerBlockType } = window.wp.blocks;
    const { InspectorControls } = window.wp.editor;
    const { PanelBody, TextControl, TextareaControl, ToggleControl } = window.wp.components;
    const { createElement } = window.wp.element;

    registerBlockType('custom-gutenberg/feature-item', {
        title: 'Feature Item',
        description: 'Icon + Title + Subtitle block',
        icon: 'info',
        category: 'custom-cards',

        attributes: {
            icon: { type: 'string', default: '' },
            title: { type: 'string', default: '' },
            subtitle: { type: 'string', default: '' },
            classes: { type: 'string', default: '' },
            anchor: { type: 'string', default: '' },
            vertical: { type: 'boolean', default: false }   // ✅ NEW
        },

        edit: function (props)
        {
            const { attributes, setAttributes } = props;
            const { icon, title, subtitle, classes, anchor, vertical } = attributes;

            let className = props.className;
            className = functions.getClassNames(className);

            // Update classes automatically if needed
            if (classes !== className) setAttributes({ classes: className });

            // Add vertical class dynamically
            const wrapperClasses =
                classes +
                ' d-flex align-items-start p-3 bg-light rounded-3' +
                (vertical ? ' vertical' : '');

            return [
                /* ======================
                   SIDEBAR SETTINGS
                ====================== */
                createElement(
                    InspectorControls,
                    {},
                    createElement(
                        PanelBody,
                        { title: 'Feature Item Settings', initialOpen: true },

                        /* Icon */
                        createElement(TextControl, {
                            label: 'Icon (text, emoji, SVG, class)',
                            value: icon,
                            onChange: (val) => setAttributes({ icon: val })
                        }),

                        /* Title */
                        createElement(TextControl, {
                            label: 'Title',
                            value: title,
                            onChange: (val) => setAttributes({ title: val })
                        }),

                        /* Subtitle */
                        createElement(TextareaControl, {
                            label: 'Subtitle',
                            value: subtitle,
                            onChange: (val) => setAttributes({ subtitle: val })
                        }),

                        /* Vertical toggle */
                        createElement(ToggleControl, {
                            label: 'Vertical layout',
                            checked: vertical,
                            onChange: (val) => setAttributes({ vertical: val })
                        })
                    )
                ),

                /* ======================
                   EDITOR PREVIEW
                ====================== */
                createElement(
                    'div',
                    { id: anchor, className: wrapperClasses },

                    // ICON
                    createElement(
                        'div',
                        { },
                        createElement(
                            'div',
                            { className: 'icon-circle bg-white shadow-sm rounded-circle d-flex align-items-center justify-content-center me-3', style: { width: '56px', height: '56px' } },
                            createElement('i', { className: icon })
                        )
                    ),

                    // TEXTS
                    createElement(
                        'div',
                        { className: 'flex-grow-1' },
                        createElement('h4', { className: 'fw-bold mb-1' }, title || 'Title'),
                        createElement('p', { className: 'text-muted mb-0' }, subtitle || 'Subtitle...')
                    )
                )
            ];
        },

        /* ======================
           FRONTEND SAVE
        ====================== */
        save: function (props)
        {
            const { icon, title, subtitle, anchor, classes, vertical } = props.attributes;

            const wrapperClasses =
                classes +
                (vertical ? ' vertical' : '');

            let iconElem = null;
            if (vertical) {
                iconElem =  createElement(
                        'div',
                        { className: 'icon-circle' },
                        createElement('i', { className: icon })
                    );
            }
            else
            {
                iconElem = createElement(
                    'div',
                    { className: '' },
                    createElement(
                        'div',
                        { className: 'icon-circle' },
                        createElement('i', { className: icon })
                    )
                );
            }

            return createElement(
                'div',
                { id: anchor, className: wrapperClasses },

                // ICON
                iconElem,

                // TEXT BLOCK
                createElement(
                    'div',
                    { className: 'flex-grow-1' },
                    title ? createElement('h4', { className: 'title' }, title) : null,
                    subtitle ? createElement('p', { className: 'subtitle' }, subtitle) : null
                )
            );
        }
    });
}
